export const FIELDS = {
  TITLE: "Title",
  BRIEF_DESCRIPTION: "Brief Description",
  DESCRIPTION: "Description",
  TOTAL_INSTALLATION_COUNT: "Total Installation Count",
  TRUST_SCORE: "Trust Score",
  ORDER: "Order",
  INSTALLATION_DETAILS: "Installation Details",
  ABOUT_US: "About Us",
  RATING: "Rating",
  REVIEW: "Review",
  PHONE: "Phone",
  CUSTOMER_IMAGES: "Customer Images",
  IMAGES: "Images",
  BRAND: "Brand",
  CATEGORY: "Select Category",
  NAME: "Name",
  SLUG: "Slug",
  TYPE: "Type",
  EMAIL: "Email",
  CITY:"City",
  USERNAME: "Username",
  ANSWERS: "Answer",
  ICON: "Icon",
  SLUG: "Slug",
  OPTION: "Options",
  ID: "ID",
  IMAGE: "Image",
  RATING: "Rating",
  REVIEWCOUNT: "reviewCount",
  LOCATION: "Location",
  TAGS: "Tags",
  SPONSORED: "Sponsored",
  RANKING: "Ranking",
  LAT: "lat",
  LNG: "lng",
  VERIFIED: "Verified",
  DESCRIPTION: "Description",
};

export const LOADING = "Loading...";
export const LOGIN = "Login";

export const ITEMS_PER_PAGE = 10;

export const TOAST_MESSAGES = {
  DATA_SAVED: "Data added successfully",
  DATA_UPDATED: "Data updated successfully",
  DELETED: "Deleted successfully",
  ERROR_ADD: "Error adding data",
  ERROR_DELETE: "Error deleting data",
  ERROR_UPDATE: "Error updating data",
};

export const MODE = {
  ADD: "add",
  UPDATE: "update",
  VIEW: "View",
  DELETE: "Delete",
  SUBMIT: "Submit",
  DROPDOWN: "dropdown",
  TEXT: "text",
};

export const TOTAL_DETAILS = {
  TOTAL_USERS: "totalUsers",
  TOTAL_PRODUCTS: "totalProducts",
  TOTAL_BLOGS: "totalBlogs",
  TOTAL_VENDORS: "totalVendors",
};
